export enum SubscriptionStatus {
    NOT_SET = "NOT_SET",
    DRAFT = "DRAFT", // Created by the user but payment is pending, (by user)
    PAID = "PAID", // Payment received and awaiting user activation. (by system)
    READY = "READY", // Ready for activation, the platform user is created. (by central)
    ACTIVE = "ACTIVE", // Activated by the user; system is monitoring the subscription. (by user)
    FINISHED = "FINISHED", // Subscription concluded successfully; user may receive payment. (by user -> system)
    FAILED = "FAILED", // Failure conditions met; subscription cannot continue. (by system/by central) 
}